<template>
        <modal :show.sync="showDesignLayoutModal" size="xl" modal-classes="modal-primary">
          <div class="row">
            <div class="col-4">
              <h6 slot="header" class="mb-0 modal-title">Diseño de Layout</h6>
            </div>
            <div class="col-8 text-right">
              <button v-if="layout.attributes.usado_en_corridas === 0" type="submit" class="btn mb-0 btn-default hover-apolo new-event--add" @click="addDesign">Guardar</button>
              <button type="button" class="btn mb-0 btn-primary hover-apolo" @click="closeModal">Cerrar</button>
            </div>
          </div>
          <form class="new-event--form mb-1" @submit.prevent="addDesign">
            <div class="row">
              <span class="ml-3">Niveles: &nbsp;</span>
              <input type="radio" id="uno" value="1" v-model="designLayout.niveles" @click="nivelesUno()" class="mb-2 mr-1"/>
              <label for="uno" class="mr-2">1</label>
              <input type="radio" id="dos" value="2" v-model="designLayout.niveles" @click="nivelesDos()" class="mb-2 mr-1"/>
              <label for="dos" class="mr-2">2</label>
              <div v-if="layout" class="col-4">
                <span v-if="designLayout.numeroAsientos > 0">Número de asientos: {{ checkNumeroAsientos() }}</span>
              </div>
            </div>
            <br>
            <span><strong>Atributos:</strong></span>
            <div class="row ml-1">
              <base-checkbox v-for="atributo in designLayout.atributos" :key="atributo.id" v-model="atributo.status" class="col-3">
                {{ atributo.nombre }}
              </base-checkbox>
            </div>
            <br>
            <div class="row">
              <span class="col-12"><strong>Estructura:</strong> &nbsp;</span>
              <br>
              <span v-if="validation != null" class="col-12 mb-3 mt-3">
                <small class="argon-error" v-text="validation"/>
              </span>
              <br>
            </div>
            <div class="row">
              <div v-if="parseInt(designLayout.niveles) === 1 || parseInt(designLayout.niveles) === 2" class="col-12">
                <div class="form-inline">
                  <label>Filas nivel 1:&nbsp;</label>
                  <input v-model="columnasUno" class="form-control col-1" type="text"/>
                  <label v-if="parseInt(designLayout.niveles) === 2">&nbsp;&nbsp;&nbsp;Filas nivel 2:&nbsp;</label>
                  <input v-if="parseInt(designLayout.niveles) === 2" v-model="columnasDos" class="form-control col-1" type="text"/>
                  <label v-if="parseInt(designLayout.niveles) === 2">&nbsp;&nbsp;&nbsp;Estas en el nivel:&nbsp;{{nivelActual}}</label>
                </div>
                <br>
                <!--INICIA SLIDER DE ASIENTOS-->
                <div v-show="mostrarNivelUno" class="box">
                  <div v-if="designLayout.estructura[0].length" v-for="(column,indexColumn) in designLayout.estructura[0]" :key="indexColumn" class="d-flex flex-row align-content-around flex-wrap">
                    <img src="/img/layout/ParteFrontal.png"  class="front-part" v-if="indexColumn === designLayout.estructura[0].length - 1">
                    <img src="/img/layout/llantaIndividual.png"  class="tires" v-if="indexColumn === designLayout.estructura[0].length - 1">
                    <img src="/img/layout/llantaIndividual.png"  class="tires2" v-if="indexColumn === designLayout.estructura[0].length - 1">
                    <box-item :categorias="categorias" :layout="layout" :removeAsiento="removeAsiento" :addAsiento="addAsiento" :checkNumeroExists="checkNumeroExists" v-model="designLayout.estructura[0][indexColumn][indexFila]" v-for="(fila,indexFila) in column" :key="(indexColumn).toString()+indexFila"></box-item>
                    <img src="/img/layout/llantaIndividual.png"  class="tires-rear" v-if="indexColumn === designLayout.estructura[0].length - 1">  
                    <img src="/img/layout/llantaIndividual.png"  class="tires-rear2" v-if="indexColumn === designLayout.estructura[0].length - 1">
                    <img src="/img/layout/parteTrasera.png" class="rear" v-if="indexColumn === designLayout.estructura[0].length - 1">
                  </div>
                </div>
                <div v-show="mostrarNivelDos" class="box">
                  <div v-if="parseInt(designLayout.niveles) === 2">
                    <div v-if="designLayout.estructura[1].length" v-for="(column,indexColumn) in designLayout.estructura[1]" :key="indexColumn" class="d-flex flex-row align-content-around flex-wrap">
                      <img src="/img/layout/ParteFrontal.png"  class="front-part" v-if="indexColumn === designLayout.estructura[0].length - 1">
                      <img src="/img/layout/llantaIndividual.png"  class="tires" v-if="indexColumn === designLayout.estructura[0].length - 1">
                      <img src="/img/layout/llantaIndividual.png"  class="tires2" v-if="indexColumn === designLayout.estructura[0].length - 1">
                      <box-item :categorias="categorias" :layout="layout" :removeAsiento="removeAsiento" :addAsiento="addAsiento" :checkNumeroExists="checkNumeroExists" v-model="designLayout.estructura[1][indexColumn][indexFila]" v-for="(fila,indexFila) in column" :key="(indexColumn).toString()+indexFila"></box-item>
                      <img src="/img/layout/llantaIndividual.png"  class="tires-rear" v-if="indexColumn === designLayout.estructura[0].length - 1">  
                      <img src="/img/layout/llantaIndividual.png"  class="tires-rear2" v-if="indexColumn === designLayout.estructura[0].length - 1">  
                      <img src="/img/layout/parteTrasera.png" class="rear" v-if="indexColumn === designLayout.estructura[0].length - 1">
                    </div>
                  </div>
                </div>
                <br>
                <div v-if="parseInt(designLayout.niveles) === 2" class="App__basic-example-controls text-center">
                  <button class="btn btn-default hover-apolo" @click.prevent="nivelUno()">
                    &laquo; Nivel 1
                  </button>
                  <button class="btn btn-default hover-apolo" @click.prevent="nivelDos()">
                    Nivel 2 &raquo;
                  </button>
                </div>
              </div>
            </div>
            <input type="hidden" class="new-event--start"/>
            <input type="hidden" class="new-event--end"/>
          </form>
          <template slot="footer">
            
          </template>
        </modal>
  </template>
  <script>
    import { Modal } from "@/components/";
    import BoxItem from "./BoxItem.vue";
    export default {
      components: {
        Modal, BoxItem
      },
      props: {
        layout: { type: Object },
        showDesignLayoutModal: Boolean, 
      },
      data() {
        return {
          validation: null,
          columnasUno: null,
          columnasDos: null,
          mostrarNivelUno: true,
          mostrarNivelDos: false,
          nivelActual: '1',
          showDefineBox: false,
          designLayout: {
            numeroAsientos: 0,
            type: "layout",
            id: null,
            nombre: null,
            niveles: null,
            atributos: [
              {
                id: 1,
                nombre: 'Wifi',
                status: false,
              },
              {
                id: 2,
                nombre: 'Pantalla Individual 6"',
                status: false,
              },
              {
                id: 3,
                nombre: 'Pantalla Individual 8"',
                status: false,
              },
              {
                id: 4,
                nombre: 'Pantallas fijas compartidas',
                status: false,
              },
              {
                id: 5,
                nombre: 'Conector USB',
                status: false,
              },
              {
                id: 6,
                nombre: 'Conector 110 V',
                status: false,
              },
              {
                id: 7,
                nombre: 'WC Individuales',
                status: false,
              },
              {
                id: 8,
                nombre: 'WC',
                status: false,
              },
              {
                id: 9,
                nombre: 'Aire Acondicionado',
                status: false,
              },
              {
                id: 10,
                nombre: 'Asientos Piel Semicama',
                status: false,
              },
              {
                id: 11,
                nombre: 'Descansa Pies',
                status: false,
              },
              {
                id: 12,
                nombre: 'Descansa Piernas',
                status: false,
              },
              {
                id: 13,
                nombre: 'Cafetería',
                status: false,
              },
              {
                id: 14,
                nombre: 'Luz Lectura',
                status: false,
              },
              {
                id: 15,
                nombre: 'Cinturón Seguridad',
                status: false,
              },
              {
                id: 16,
                nombre: 'Confort',
                status: false,
              },
              {
                id: 17,
                nombre: 'Básica',
                status: false,
              },
              {
                id: 18,
                nombre: 'Ejecutiva',
                status: false,
              },
              {
                id: 19,
                nombre: 'Doble Piso',
                status: false,
              },
            ],
            estructura:[
              [],
              [],
            ]
          },
          categorias: null,
        };
      },
      created() {
        this.categorias = this.layout.categorias;

        const atributos = JSON.parse(this.layout.attributes.atributos);
        if(atributos != null){
          this.designLayout.atributos = atributos;
        }
        
        const estructura = JSON.parse(this.layout.attributes.estructura);
        if(estructura != null){
          if(estructura[0].length){
            this.designLayout.estructura[0] = estructura[0];
            this.columnasUno = (estructura[0].length * estructura[0][0].length) / 5;
          }
          if(estructura[1].length){
            this.designLayout.estructura[1] = estructura[1];
            this.columnasDos = (estructura[1].length * estructura[1][0].length) / 5;
          }
        }

        this.designLayout.numeroAsientos = this.layout.attributes.numero_asientos;
        this.designLayout.niveles = this.layout.attributes.niveles;
        this.designLayout.nombre = this.layout.attributes.nombre;
      },
      watch:{
        columnasUno(value){
          if(Number(value) > 0){
            for(let i = 0; i < 5; i++){
              if(!!this.designLayout.estructura[0][i] === false){
                this.designLayout.estructura[0][i] = [];
              }
              for(let j = 0; j < value; j++){
                if(typeof this.designLayout.estructura[0][i][j] === 'undefined'){
                  this.designLayout.estructura[0][i][j] = null;
                }
              }
              if(Number(value) < this.designLayout.estructura[0][i].length){
                this.designLayout.estructura[0][i].splice(Number(value), this.designLayout.estructura[0][i].length - Number(value))
              }
            }
          }
        },
        columnasDos(value){
          if(Number(value) > 0){
            for(let i = 0; i < 5; i++){
              if(!!this.designLayout.estructura[1][i] === false){
                this.designLayout.estructura[1][i] = [];
              }
              for(let j = 0; j < value; j++){
                if(typeof this.designLayout.estructura[1][i][j] === 'undefined'){
                  this.designLayout.estructura[1][i][j] = null;
                }
              }
              if(Number(value) < this.designLayout.estructura[1][i].length){
                this.designLayout.estructura[1][i].splice(Number(value), this.designLayout.estructura[1][i].length - Number(value))
              }
            }
          }
        },
      },
      computed: {
        
      },

      methods: {
        nivelesUno(){
          this.designLayout.estructura[1] = [];
          this.checkNumeroAsientos();
          this.mostrarNivelUno = true;
          this.mostrarNivelDos = false;
          this.columnasDos = null;
        },
        nivelesDos(){
          this.checkNumeroAsientos();
          this.mostrarNivelUno = true;
          this.mostrarNivelDos = false;
        },
        nivelUno(){   
          this.mostrarNivelUno = true;
          this.mostrarNivelDos = false;
          this.nivelActual = '1';
        },
        nivelDos(){
          this.mostrarNivelUno = false;
          this.mostrarNivelDos = true;
          this.nivelActual = '2';
        },
        checkNumeroExists(val){
          let existe = false;
          for(let i = 0; i < 5; i++){
              for(let j = 0; j < this.designLayout.estructura[0][i].length; j++){
                if(this.designLayout.estructura[0][i][j] != null && this.designLayout.estructura[0][i][j].numero == val){
                  existe = true;
                  break;
                }
              }
              if(this.designLayout.estructura[1] != null){
                for(let j = 0; j < this.designLayout.estructura[1].length; j++){
                  if(this.designLayout.estructura[1][i][j] != null && this.designLayout.estructura[1][i][j].numero == val){
                    existe = true;
                    break;
                  }
                }
              }
            }
            return existe;
        },
        checkNumeroAsientos(){
          let asientos = 0;
          if(this.designLayout.estructura[0].length > 0){
            for(let i = 0; i < 5; i++){
              for(let j = 0; j < this.designLayout.estructura[0][i].length; j++){
                if(this.designLayout.estructura[0][i][j] != null && this.designLayout.estructura[0][i][j].tipo === "asiento"){
                  asientos++;
                }
              }
            }
          }
          if(this.designLayout.estructura[1].length > 0){
            for(let i = 0; i < 5; i++){
              for(let j = 0; j < this.designLayout.estructura[1][i].length; j++){
                if(this.designLayout.estructura[1][i][j] != null && this.designLayout.estructura[1][i][j].tipo === 'asiento'){
                  asientos++;
                }
              }
            }
          }
          return asientos;
        },
        addAsiento(){
          this.designLayout.numeroAsientos = Number(this.designLayout.numeroAsientos) + 1;
        },
        removeAsiento(){
          this.designLayout.numeroAsientos = Number(this.designLayout.numeroAsientos) - 1;
        },
        validationFinal(){
          let existe = false;
          for(let i = 0; i < this.designLayout.estructura[0].length; i++){
            for(let j = 0; j < this.designLayout.estructura[0][i].length; j++){
              if(this.designLayout.estructura[0][i][j] != null && this.designLayout.estructura[0][i][j].tipo == 'asiento'){
                if(this.designLayout.estructura[0][i][j].numero === null || this.designLayout.estructura[0][i][j].numero === '' || this.designLayout.estructura[0][i][j].categoria === null){
                  existe = true;
                  break;
                }
              }
            }
            if(this.designLayout.estructura[1] != null){
              for(let j = 0; j < this.designLayout.estructura[1].length; j++){
                if(this.designLayout.estructura[1][i][j] != null && this.designLayout.estructura[1][i][j].tipo == 'asiento'){
                  if(this.designLayout.estructura[1][i][j].numero === null || this.designLayout.estructura[1][i][j].numero === '' || this.designLayout.estructura[1][i][j].categoria === null){
                    existe = true;
                    break;
                  }
                }
              }
            }
          }
          return existe;
        },
        async addDesign() {
          let validation = this.validationFinal();
          if(validation){
            this.validation = 'Existen asientos sin número y/o categoría asignada.';
          }else{
            this.designLayout.numeroAsientos = this.checkNumeroAsientos();
            this.designLayout.id = this.layout.id;
            this.designLayout.nombre = this.layout.nombre;
            try {
            await this.$store.dispatch("layouts/update", this.designLayout);
            this.validation = null;
            this.$notify({
              type: "success",
              message: "Diseño de layout guardado satisfactoriamente.",
              duration: -1
            });
            //this.resetApiValidation();
            } catch (error) {
              if (error.response.data.errors[0]) {
                this.$notify({
                    type: "danger",
                    message: error.response.data.errors[0].detail,
                    duration: -1
                });
              } else {
                  this.$notify({
                      type: "danger",
                      message: "Oops, ha ocurrido un problema!",
                      duration: -1
                  });
              }
              //this.setApiValidation(error.response.data.errors);
            }
            this.closeModal();
          }
        },
        closeModal(){
          this.$emit('event');
          let documentClasses = document.body.classList;
          documentClasses.remove("modal-open");
          this.showDesignLayoutModal = false;
        },
      },
    };
  </script>
  <style scoped>
    .argon-error {
      position: relative;
      bottom: 0px;
      color: #fb6340;
    }
    .front-part {
      position: absolute;
      margin-top: -21.5%;
      margin-left: -6.7%;
      width: 6.85%;
    }

    .tires {
      position: absolute;
      margin-top: -22.5%;
      margin-left: 0.5%;
      width: 4.5%;
      z-index: 0;
    }

    .tires2 {
      position: absolute;
      margin-top: 5.5%;
      margin-left: 0.5%;
      width: 4.5%;
      z-index: 0;
    }

    .tires-rear {
      position: relative;
      margin-top: -25.15%;
      margin-left: -5.25%;
      width: 5.1%;
      height: 100%;
      z-index: 0;
    }

    .tires-rear2 {
      position: relative;
      margin-top: 6.1%;
      margin-left: -5.25%;
      width: 5%;
      height: 100%;
      z-index: 0;
    }

    .rear{
      position: relative;
      margin-top: -22.8%;
      margin-left: 1%;
      width: 1.4%;
      height: 100%;
    }

    .box {
      margin-left: 8%;
    }


    @media (max-width: 768px) {
    .front-part {
        margin-top: -15%;
    }

    .tires {
        margin-top: -16%;
    }

    .tires-rear {
        margin-top: -16%;
    }

    .rear {
        top: -15%;
    }
}

    @media (max-width: 576px) {
    .front-part {
        margin-top: -10%;
    }

    .tires {
        margin-top: -11%;
    }

    .tires-rear {
        margin-top: -11%;
    }

    .rear {
        top: -10%;
    }
}

    @media (min-width: 1024px) and (max-width: 1024px) {
    .front-part {
        margin-top: -35.8%;
        margin-left: -11%;
        width: 11.4%;
    }

    .tires {
        margin-top: -38%;
        margin-left: 0.8%;
        width: 7.5%;
    }

    .tires-rear {
        margin-top: -43.5%;
        margin-left: -9.3%;
        width: 8.6%;
    }

    .rear {
        margin-top: -37.5%;
        margin-left: 1.7%;
        width: 2.25%;
    }
    .box {
      margin-left: 9%;
    }
}
</style>
  